/**
 * Global Utility Functions
 */

if (typeof window.Shopify === 'undefined') {
    window.Shopify = {};
}

/**
 * Currency formatting
 * Uses the window.moneyFormat or fallback
 * @param {Number|String} cents - The price in cents
 * @param {String} format - Optional format string
 */
window.Shopify.formatMoney = function (cents, format) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || window.moneyFormat || '${{amount}}';

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

(() => {
    var WTS_SELECTOR = '[data-wts-section]';
    var DURATION = 6000;
    var instances = new WeakMap();

    function loadVideo(item) {
        if (!item || item.dataset.videoLoaded === 'true') return;
        
        var videoType = item.dataset.videoType;
        var wrapper = item.querySelector('[data-video-wrapper]');
        if (!wrapper) return;

        if (videoType === 'mp4') {
            var placeholder = wrapper.querySelector('[data-video-placeholder]');
            var videoSrc = item.dataset.videoSrc;
            if (placeholder && videoSrc) {
                var video = document.createElement('video');
                video.className = 'wts-video wts-video--mp4';
                video.src = videoSrc;
                video.loop = true;
                video.muted = true;
                video.playsInline = true;
                video.preload = 'metadata';
                placeholder.replaceWith(video);
            }
        } else if (videoType === 'external') {
            var container = wrapper.querySelector('[data-external-container]');
            var extPlaceholder = container && container.querySelector('[data-video-placeholder]');
            var host = item.dataset.videoHost;
            var videoId = item.dataset.videoId;
            var title = item.dataset.videoTitle || '';
            
            if (extPlaceholder && host && videoId) {
                var iframe = document.createElement('iframe');
                iframe.allowFullscreen = true;
                iframe.loading = 'lazy';
                iframe.title = title;
                
                if (host === 'youtube') {
                    iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=0&mute=1&loop=1&playlist=' + videoId + '&controls=0&rel=0&playsinline=1&enablejsapi=1';
                    iframe.allow = 'autoplay; encrypted-media';
                } else if (host === 'vimeo') {
                    iframe.src = 'https://player.vimeo.com/video/' + videoId + '?autoplay=0&muted=1&loop=1&background=1';
                    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
                }
                extPlaceholder.replaceWith(iframe);
            }
        }
        
        item.dataset.videoLoaded = 'true';
    }

    function initSection(section) {
        if (!section) return;
        var existing = instances.get(section);
        if (existing) existing.cleanup();

        var main = section.querySelector('.wts-main');
        var mainItems = Array.prototype.slice.call(section.querySelectorAll('.wts-main-item'));
        var playlistItems = Array.prototype.slice.call(section.querySelectorAll('.wts-playlist-item'));
        if (!main || mainItems.length === 0 || playlistItems.length === 0) return;

        var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        var currentIndex = 0;
        var timer = null;
        var isHoveringMain = false;
        var autoPlayStopped = false;
        var isInViewport = false;
        var hasStarted = false;

        var controller = new AbortController();
        var signal = controller.signal;

        function updateAria(index, active) {
            var item = playlistItems[index];
            var mainItem = mainItems[index];
            if (item) item.setAttribute('aria-pressed', active ? 'true' : 'false');
            if (mainItem) mainItem.setAttribute('aria-hidden', active ? 'false' : 'true');
        }

        function resetProgressBar(index) {
            var bar = playlistItems[index] && playlistItems[index].querySelector('.wts-progress-fill');
            if (!bar) return;
            bar.style.transition = 'none';
            bar.style.width = '0%';
        }

        function startProgress(index) {
            if (isHoveringMain || autoPlayStopped || !isInViewport) return;
            var bar = playlistItems[index] && playlistItems[index].querySelector('.wts-progress-fill');
            if (!bar) return;
            bar.style.transition = 'none';
            bar.style.width = '0%';
            void bar.offsetWidth;
            bar.style.transition = 'width ' + DURATION + 'ms linear';
            bar.style.width = '100%';
            clearTimeout(timer);
            timer = setTimeout(function () {
                switchItem(currentIndex + 1);
            }, DURATION);
        }

        function playCurrentVideo() {
            var activeItem = mainItems[currentIndex];
            var wrapper = activeItem && activeItem.querySelector('.wts-media-wrapper');
            if (!activeItem || !wrapper) return;
            
            loadVideo(activeItem);
            wrapper.classList.add('is-playing');
            
            if (activeItem.dataset.videoType === 'mp4') {
                var video = activeItem.querySelector('video');
                if (video) video.play();
            } else if (activeItem.dataset.videoType === 'external') {
                var iframe = activeItem.querySelector('iframe');
                if (iframe && iframe.src.indexOf('autoplay=0') !== -1) {
                    iframe.src = iframe.src.replace('autoplay=0', 'autoplay=1');
                }
            }
        }

        function pauseCurrentVideo() {
            var activeItem = mainItems[currentIndex];
            var wrapper = activeItem && activeItem.querySelector('.wts-media-wrapper');
            if (!activeItem || !wrapper) return;
            wrapper.classList.remove('is-playing');
            if (activeItem.dataset.videoType === 'mp4') {
                var video = activeItem.querySelector('video');
                if (video) {
                    video.pause();
                    video.currentTime = 0;
                }
            }
        }

        function switchItem(newIndex) {
            var nextIndex = newIndex >= mainItems.length ? 0 : newIndex;
            pauseCurrentVideo();

            mainItems[currentIndex].classList.remove('is-active');
            playlistItems[currentIndex].classList.remove('is-active');
            updateAria(currentIndex, false);
            resetProgressBar(currentIndex);

            currentIndex = nextIndex;
            
            loadVideo(mainItems[currentIndex]);
            
            mainItems[currentIndex].classList.add('is-active');
            playlistItems[currentIndex].classList.add('is-active');
            updateAria(currentIndex, true);

            startProgress(currentIndex);
            if (!canHover) {
                playCurrentVideo();
            }
        }

        function forceSwitch(index) {
            clearTimeout(timer);
            switchItem(index);
        }

        function pauseAutoRotate() {
            clearTimeout(timer);
            var bar = playlistItems[currentIndex] && playlistItems[currentIndex].querySelector('.wts-progress-fill');
            if (!bar) return;
            var width = getComputedStyle(bar).width;
            bar.style.transition = 'none';
            bar.style.width = width;
        }

        function resumeAutoRotate() {
            if (isInViewport) {
                startProgress(currentIndex);
            }
        }

        function stopAutoPlayOnMobile() {
            if (!canHover && !autoPlayStopped) {
                autoPlayStopped = true;
                clearTimeout(timer);
                resetProgressBar(currentIndex);
            }
        }

        function onEnterViewport() {
            isInViewport = true;
            if (!hasStarted) {
                hasStarted = true;
                loadVideo(mainItems[currentIndex]);
                startProgress(currentIndex);
                if (!canHover) {
                    playCurrentVideo();
                }
            } else {
                resumeAutoRotate();
                if (!canHover && !autoPlayStopped) {
                    playCurrentVideo();
                }
            }
        }

        function onLeaveViewport() {
            isInViewport = false;
            pauseAutoRotate();
            pauseCurrentVideo();
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    onEnterViewport();
                } else {
                    onLeaveViewport();
                }
            });
        }, { threshold: 0.2 });

        observer.observe(section);

        playlistItems.forEach(function (item, index) {
            item.addEventListener('click', function () {
                stopAutoPlayOnMobile();
                forceSwitch(index);
            }, { signal: signal });
            item.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    stopAutoPlayOnMobile();
                    forceSwitch(index);
                }
            }, { signal: signal });
        });

        main.addEventListener('mouseenter', function () {
            isHoveringMain = true;
            pauseAutoRotate();
            playCurrentVideo();
        }, { signal: signal });

        main.addEventListener('mouseleave', function () {
            isHoveringMain = false;
            resumeAutoRotate();
            pauseCurrentVideo();
        }, { signal: signal });

        instances.set(section, {
            cleanup: function () {
                controller.abort();
                clearTimeout(timer);
                observer.disconnect();
                pauseCurrentVideo();
            }
        });
    }

    function initAll() {
        var sections = document.querySelectorAll(WTS_SELECTOR);
        Array.prototype.forEach.call(sections, initSection);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
        initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
        var section = event.target.querySelector(WTS_SELECTOR) || event.target.closest(WTS_SELECTOR);
        if (section) initSection(section);
    });

    document.addEventListener('shopify:section:unload', function (event) {
        var section = event.target.querySelector(WTS_SELECTOR) || event.target.closest(WTS_SELECTOR);
        if (!section) return;
        var instance = instances.get(section);
        if (instance) instance.cleanup();
        instances.delete(section);
    });
})();
